export default {
  baseURL: ''
}
